import { Chip } from "@mui/material";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import DataTable from "../../components/enterprise/DataTable";
import { platformMockService } from "../../services/mock/platformMockService";
import { analyticsTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const StoreComparisonPage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  const rows = showMockData ? platformMockService.getRiskScores() : [];
  const columns = [
    { key: "scope", header: t("platform.topbar.store") },
    { key: "score", header: t("platform.common.risk") },
    { key: "trend", header: t("platform.common.trend") },
    { key: "factors", header: t("platform.common.topFactor"), render: (row) => row.factors?.[0] || "-" },
    { key: "dataMode", header: t("platform.common.source"), render: () => <Chip size="small" label={t("platform.dataMode.demo")} color="secondary" variant="outlined" /> },
  ];
  return (
    <ModuleLayout title={t("platform.pages.storeComparison.title")} subtitle={t("platform.pages.storeComparison.subtitle")} breadcrumbs={[t("platform.nav.analytics"), t("platform.tabs.stores")]} tabs={analyticsTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? <DataTable columns={columns} rows={rows} /> : <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledAnalyticsDescription")} />}
    </ModuleLayout>
  );
};

export default StoreComparisonPage;
